import { createFileRoute, Outlet } from '@tanstack/react-router'

import { defaultMembership } from '@/api/mem/memberMembership'
import { defaultMember } from '@/api/members'
import {
    mainMembershipQueryOptions
} from '@/api/membershipQueryOptions'
import { ApiErrorComponent } from '@/components/ApiErrorComponent'
import LoadProgress from '@/components/LoadProgress'
import ChangeScoutstateDialog from '@/dialog/ChangeScoutstateDialog'
import ChangeSectionDialog from '@/dialog/ChangeSectionDialog'
import { setCurrentMember } from '@/store/nav/navSlice'
import ContactIcon from '@/ui/icons/ContactIcon'
import MemberAddIcon from '@/ui/icons/MemberAddIcon'
import MemberFullIcon from '@/ui/icons/MemberFullIcon'
import MemberSidebar from '@/ui/member/MemberSidebar'
import {
    Box,
    Chip,
    IconButton,
    Stack,
    Tooltip
} from '@mui/material'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { t } from 'i18next'
import React from 'react'
import { useDispatch } from 'react-redux'
import { memberQueryOptions } from '../../api/memberQueryOptions'

export const Route = createFileRoute('/_auth/member_/$memberUuid')({
    component: MemberComponent,
})

function MemberComponent() {
    const params = Route.useParams()
    const memberQuery = useQuery(memberQueryOptions(params.memberUuid))
    const member = memberQuery.data || defaultMember

    const membershipQuery = useSuspenseQuery(
        mainMembershipQueryOptions(params.memberUuid),
    )
    const membership = membershipQuery.data || defaultMembership

    // const router = useRouter()
    // const state = router.history.location.state

    const [changeScoutstateOpen, setChangeScoutstateOpen] = React.useState(false)

    const openChangeScoutstateDialog = () => {
        const writeable = membership.permissions
            ? membership.permissions.some((perm) => perm === 'write')
            : false
        if (writeable) {
            setChangeScoutstateOpen(true)
        }
    }

    const [changeSectionOpen, setChangeSectionOpen] = React.useState(false)
    const openChangeSectionDialog = () => {
        setChangeSectionOpen(true)
    }

    const dispatch = useDispatch();

    if (memberQuery.isLoading || memberQuery.isFetching) {
        return <LoadProgress />
    }
    if (membershipQuery.isLoading || membershipQuery.isFetching) {
        return <LoadProgress />
    }

    if (memberQuery.isError) {
        return <ApiErrorComponent error={memberQuery.error} />
    }
    if (membershipQuery.isError) {
        return <ApiErrorComponent error={membershipQuery.error} />
    }

    dispatch(setCurrentMember(member));

    const section = membership.properties.section
    const sec = JSON.parse(section || '{}')

    return (
        <>
            <Box>
                <Stack direction="row" spacing={1} sx={{ px: 0 }}>
                    <IconButton onClick={openChangeScoutstateDialog}>
                        {'MEMBER_FULL' == membership.scoutstate ? (
                            <Tooltip title={t('enum.scoutstate.MEMBER_FULL')}>
                                <MemberFullIcon />
                            </Tooltip>

                        ) : 'MEMBER_ADD' == membership.scoutstate ? (
                            <Tooltip title={t('enum.scoutstate.MEMBER_ADD')}>
                                <MemberAddIcon />
                            </Tooltip>
                        ) : (
                            <Tooltip title={t('enum.scoutstate.CONTACT')}>
                                <ContactIcon />
                            </Tooltip>
                        )}
                    </IconButton>

                    <span>
                        <b>
                            {member.scoutId} - {member.firstname} {member.lastname}
                        </b>
                    </span>
                    <span>&nbsp;</span>

                    {sec.section && (
                        <Tooltip
                            title={sec.section.name}
                            key={sec.uuid}
                            onClick={openChangeSectionDialog}
                        >
                            <Chip
                                color="primary"
                                style={{ backgroundColor: sec.section.color }}
                                label={sec.section.abbreviation}
                                size="small"
                            />
                        </Tooltip>
                    )}

                </Stack>
            </Box>
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    height: { xs: `calc(100% - 40px)` },
                    px: 0
                }}>
                <MemberSidebar
                    memberUuid={params.memberUuid}
                    membershipUuid={membership.uuid}
                />
                <Box sx={{ width: { xs: '100%', md: `calc(100% - 240px)` }, height: '100%' }}>
                    <Outlet />
                </Box>
            </Stack>
            <ChangeScoutstateDialog open={changeScoutstateOpen} setOpen={setChangeScoutstateOpen} membership={membership} />
            <ChangeSectionDialog open={changeSectionOpen} setOpen={setChangeSectionOpen} membership={membership} />
        </>
    );
}
